<h1 mat-dialog-title>Turnos en espera</h1>
<div mat-dialog-content>
  <div
    style="max-height: 200px; overflow-y: scroll"
    class="card-content margin-botton-medium"
  >
    <mat-spinner *ngIf="loading"></mat-spinner>
    <table
      *ngIf="!loading"
      class="search-table"
      mat-table
      [dataSource]="dataSource"
    >


    <ng-container matColumnDef="date">
      <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
          <resizable-column-control width="150" tile="Fecha" #resColFecha></resizable-column-control>
      </th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
          <div><b>{{ element.Date |  date: 'dd/MM/yyyy'}}</b></div>
      </td>
  </ng-container>
  <ng-container matColumnDef="dateContact">
    <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
        <resizable-column-control width="150" tile="Fecha pref." #resColFecha></resizable-column-control>
    </th>
    <td class="search-table-cell" mat-cell *matCellDef="let element">
        <div><b>{{ element.DateContact }}</b></div>
    </td>
</ng-container>
<ng-container matColumnDef="timeContact">
  <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
      <resizable-column-control width="150" tile="Hora pref." #resColFecha></resizable-column-control>
  </th>
  <td class="search-table-cell" mat-cell *matCellDef="let element">
      <div><b>{{ element.TimeContact }}</b></div>
  </td>
</ng-container>
  <ng-container matColumnDef="patientFullName">
      <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
          <resizable-column-control width="150" tile="Paciente" #resColPatient></resizable-column-control>
      </th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
          <div >{{ element.PatientFullName }}</div>
      </td>
  </ng-container>
  <ng-container matColumnDef="patientCelPhone">
        <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
            <resizable-column-control width="50" tile="Celular" #resColPatient></resizable-column-control>
        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element">
            <div >{{ element.PatientCelPhone }}</div>
        </td>
    </ng-container>
    <ng-container matColumnDef="stateName">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Estado" #resColPatient></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div >{{ element.StateName }}</div>
            </td>
        </ng-container>

  <ng-container matColumnDef="serviceName">
    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
        <resizable-column-control width="150" tile="Servicio" #resColPractice></resizable-column-control>
    </th>
    <td  class="search-table-cell" mat-cell *matCellDef="let element">
        <div>{{ element.ServiceName }}</div>
    </td>
</ng-container>


      <tr
        mat-header-row
        class="search-table-header"
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>
      <tr
        (click)="asociateBudget(row)"
        mat-row
        class="search-table-cell"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Cancelar
    </button>
  </div>
</div>
